import React from "react";
import { Navigate } from "react-router-dom";
import { FeatureFlagGuard } from "Components/FeatureFlagGuard/FeatureFlagGuard";
import {
  NotForMissionOperatorGuard,
  OnlyForAdminGuard,
} from "./NavigationGuards";
import { RealTimeMapPage } from "Pages/RealTimeMap/RealTimeMap.page";
import { MissionPlannerPage } from "Pages/MissionPlanner/MissionPlanner.page";
import { WelcomePage } from "Pages/Welcome/Welcome.page";
import { VehiclesListPage } from "Pages/VehiclesList/VehiclesList.page";
import { VehicleTypesListPage } from "Pages/VehicleTypesList/VehicleTypesList.page";
import { FleetsListPage } from "Pages/FleetsList/FleetsList.page";
import { UsersListPage } from "Pages/UsersList/UsersList.page";
import { OTAManagementPage } from "Pages/OTAManagement/OTAManagement.page";
import { IntersectionsPage } from "Pages/Intersections/Intersections.page";
import { StationViewPage } from "Pages/StationView/StationView.page";
import { LiveMissionsPage } from "Pages/LiveMissions/LiveMissions.page";
import { LiveMissionsPage as LiveMissionsPageWrapper } from "Pages/LiveMissionsPage/LiveMissionsPage.page";
import { QueueManagerPage } from "Pages/QueueManagerPage/QueueManagerPage.page";
import { VCMSPage } from "Pages/VCMS/VCMS.page";

export const QUEUE_MISSIONS_PATH = "/queued_missions";
export const LIVE_MISSIONS_PATH = "/live_missions";
export const MISSIONS_PATH = "/missions";

export const AuthorizedRouter = [
  {
    path: "",
    element: (
      <NotForMissionOperatorGuard>
        <RealTimeMapPage />
      </NotForMissionOperatorGuard>
    ),
  },
  {
    path: "/station",
    element: <StationViewPage />,
  },
  {
    // Preserve old bookmarks: redirect /operator to /station for one release cycle.
    path: "/operator",
    element: <Navigate to="/station" replace />,
  },
  {
    path: "/intersections",
    element: <IntersectionsPage />,
  },
  {
    path: MISSIONS_PATH,
    element: <MissionPlannerPage />,
  },
  {
    path: `${MISSIONS_PATH}/list`,
    element: <MissionPlannerPage />,
  },
  {
    path: "",
    element: <LiveMissionsPageWrapper />,
    children: [
      {
        path: LIVE_MISSIONS_PATH,
        element: (
          <FeatureFlagGuard flag="LIVE_MISSIONS">
            <LiveMissionsPage />
          </FeatureFlagGuard>
        ),
      },
      {
        path: QUEUE_MISSIONS_PATH,
        element: (
          <FeatureFlagGuard flag="QUEUE_MANAGER">
            <QueueManagerPage />
          </FeatureFlagGuard>
        ),
      },
    ],
  },
  {
    path: "/welcome",
    element: <WelcomePage />,
  },
  {
    path: "/vehicles",
    element: (
      <OnlyForAdminGuard>
        <VehiclesListPage />
      </OnlyForAdminGuard>
    ),
  },
  {
    path: "/vehicletypes",
    element: (
      <OnlyForAdminGuard>
        <VehicleTypesListPage />
      </OnlyForAdminGuard>
    ),
  },
  {
    path: "/fleets",
    element: (
      <OnlyForAdminGuard>
        <FleetsListPage />
      </OnlyForAdminGuard>
    ),
  },
  {
    path: "/people",
    element: (
      <OnlyForAdminGuard>
        <UsersListPage />
      </OnlyForAdminGuard>
    ),
  },
  {
    path: "/vcms/*",
    element: <VCMSPage />,
  },
  {
    path: "/ota",
    element: (
      <OnlyForAdminGuard>
        <OTAManagementPage />
      </OnlyForAdminGuard>
    ),
  },
  {
    path: "*",
    element: <Navigate to="/" replace />,
  },
];
